import React from "react";
import Picture from "../../../shared/components/Picture";
import { formatImageUrl } from "../../../shared/utils";
import { actionTypes } from "../../../shared/hooks/useVideo";
import { useReactAppState } from "../../../shared/containers/utils";
import PlayIcon from "../../../shared/svg/PlayIcon/PlayIcon";
import { formatVideoDuration } from "../../utils";

const PlaylistItem = ({ isVideoPlaying, isCurrentItem, updateVideo, index, item }) => {
  const { t } = useReactAppState();
  const { highQuality } = item?.thumbnail?.templateUrl ? formatImageUrl(item.thumbnail.templateUrl, { format: "w_175,c_scale", extension: "f_png" }) : {};

  const { duration = 0 } = item?.fields || {};

  return (
    <div
      className={`mls-c-video-component__playlist-item ${isCurrentItem ? "mls-c-video-component__playlist-item--current" : ""}`}
      onClick={() => updateVideo({ type: actionTypes.currentVideoPos, payload: index })}
      tabIndex="0">
      <div className="d3-o-media-object">
        <div className="d3-o-media-object__body">
          {
            isCurrentItem && isVideoPlaying
              ? (
                <span className="mls-o-label">
                  {t("brightcove_playing")}
                  <Picture fallbackSrc={null} loadingSrc={null} src={'/assets/images/AudioMicroAnimation-40x40.gif'} />
                </span>
              )
              : null
          }
          <span className="d3-o-media-object__title">{item?.title}</span>
        </div>
        <figure className="d3-o-media-object__figure">
          <div className={`mls-o-video__lock`}>
            <div className="mls-o-video__lock-label-container">
              <span className="mls-o-video__lock-label">
                {formatVideoDuration(duration)}
              </span>
            </div>
            <div role="img" className="mls-o-video__play-icon-container">
              <PlayIcon height={6} width={3} />
            </div>
          </div>
          {
            highQuality
              ? <Picture src={highQuality} loadingSrc={null} fallbackSrc={null} title={item.title} />
              : null
          }
        </figure>
      </div>
    </div>
  );
};

export default PlaylistItem;
